import { cleanContent, moveWidgetsToMainContent } from '@helpers/helpers.js';
import swiperWidget from '@commonWidgets/slider.js';
import countdown from '@commonWidgets/countdown.js';
import masonryCards from '@commonWidgets/masonryCards.js';
import seoWidget from '@commonWidgets/seo.js';
import sfSignup from '@commonWidgets/signupText.js';
import sponsorWidget from '@commonWidgets/sponsors.js';
import gridGallery from '@commonWidgets/gallery.js';

// create a token for the common routes

export default function (themes) {
  const { classHome: stateFairHome, idContainer: widgetContainer } = themes[1];
  const isStateFairHome = $('body').hasClass(stateFairHome);

  function cloneSocialIcons() {
    const socialBar = $('.socialNetworks').children();
    // select the childrens that not have the class 'socialLinks'
    const socialIcons = socialBar.filter(function () {
      return !$(this).hasClass('socialNetworkLink');
    });

    const socialIconsContainer = $('.fair-social__networks');
    const socialIconsClone = socialIcons.clone();
    socialIconsClone.each(function () {
      const img = $(this).find('img');
      img.removeAttr('style');
      const src = img.attr('src').split('.png')[0];
      img.attr('src', src + '.png');
    });
    socialIconsContainer.append(socialIconsClone);
  }

  if (isStateFairHome) {
    $(document).ready(function () {
      cleanContent(stateFairHome);
      moveWidgetsToMainContent(widgetContainer);
      swiperWidget('sfSwiperWidget', sfSwiperWidgetOpts);
      countdown('sfDatesWidget', sfDatesWidgetOpts);
      masonryCards('sfTwoCardsWidget', sfTwoCardsWidgetOpts, 2);
      masonryCards('sfFourCardsWidget', sfFourCardsWidgetOpts, 4);
      seoWidget('sfSeoWidget', sfSeoWidgetOpts);
      sfSignup('sfSignup', sfSignupOpts, false);
      sponsorWidget();
      gridGallery('sfGridGallery', sfGridGalleryOpts);
    });
    $(window).load(function () {
      cloneSocialIcons();
    });
  }
}
